import * as React from "react";
import Settings from "./Settings";
import Home from "./Home";
import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import "./style.scss";

interface AppProps {
  title: string;
}

const App: React.FC<AppProps> = (props: AppProps) => {
  return (
    <Routes>
      <Route element={<Layout title={props.title} />}>
        <Route path="/" element={<Home />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
};

export default App;